<template>
    <div class="page">
        <h1>Thank You</h1>
        <h2>We have received your message and will be in touch!</h2>
        <router-link class="button" :to="{ name: 'Profile' }">
            View Profile
        </router-link>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'SubmissionSuccess',
    methods: {
        ...mapActions(['hideMenu', 'hideFooter'])
    },
    created() {
        this.hideMenu();
        this.hideFooter();
    }
}
</script>

<style scoped>
.page {
    background: radial-gradient(ellipse at center, #1b2735 0%,#090a0f 100%);
    margin-top: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
}
.page h1, .page h2 {
    color: white;
    align-self: center;
    text-align: center;
    margin: 0;
}
.page h2 {
    font-family: lato-regular;
    margin-top: 10px;
    margin-bottom: 40px;
}
.button {
    align-self: center;
}
.button:hover {
    background: var(--light-blue);
    border-color: var(--light-blue);
}
</style>